import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import KitSelectStyle from './KitSelect.module.css'
import renderImage from '../../source/importImg'
import getBackendImage from '../../source/imageUtil'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { fetchVersion } from './FlashFiles'
import { MenuItem, Select } from '@material-ui/core'
import { setLanguageSelect, setSelectionBackRoute } from '../../redux/actions'
import { connect } from 'react-redux'
import { languageMenu, languageWords } from '../../utils/langaugeSupport'
import { codableKits, tabs } from '../../utils/kitTabs'
import { getVersionArguments } from '../../utils/verionControl'

const BACKEND_URL = process.env.REACT_APP_API_BASE

// Hardcoded image keys per program id (uses renderImage)
const PROGRAM_IMAGE_MAP = {
    toki: 'talkingDragon',
    poki: 'PokiRoverKit',
    makeyExpansionKit: 'makeyExpansionKit',

    ioExpansionKit1: 'PokiRoverKit',
    ioExpansionKit2: 'ioExpansionKit2',

    roverExpansionKit1: 'PokiRoverKit',
    roverExpansionKit2: 'ioExpansionKit2',
    woofExpansionKit3: 'woofExpansionKit3',
    roarmExpansionKit4: 'roarmExpansionKit4',
    walkerExpansionKit5: 'walkerExpansionKit5',

    omniBotRoverExpansionKit: 'omniBotRoverExpansionKit',
    omniBotShooterExpansionKit: 'omniBotShooterExpansionKit',
    spidyExpansionKit: 'spidyExpansionKit',
    integratedRoboticsExpansionKit: 'integratedRoboticsExpansionKit',
}

// Routes per program id for user-facing engine
const PROGRAM_ENGINE_ROUTE = {
    toki: '/kitMenu',
    poki: '/kitMenu',
}

// Message shown on expansion kits that have no projects yet.
// Kept here so the copy can be changed in one place.
const COMING_SOON_TEXT = 'Coming soon!'

// const tabs = [
//     {
//         id: 1,
//         title: 'CodableKits',
//         defaultDevice: 'Ace',
//         content: [
//             {
//                 device: 'Moki',
//                 name: 'Moki',
//                 src: 'moki',
//                 nav: '',
//             },
//             {
//                 device: 'Toki',
//                 name: 'Toki',
//                 src: 'toki',
//                 nav: '',
//             },
//             {
//                 device: 'Poki',
//                 name: 'Poki',
//                 src: 'tokiPlus',
//                 nav: '',
//             },
//             {
//                 device: 'Roboki',
//                 name: 'Roboki',
//                 src: 'roboki',
//                 nav: '',
//             },
//             {
//                 device: 'Ace1',
//                 name: 'PeeCee',
//                 src: 'peeCeeB',
//                 nav: '',
//             },

//             {
//                 device: 'Ace0',
//                 name: 'PeeCee v0.1',
//                 src: 'peeCeeA',
//                 nav: '',
//             },
//         ],
//     },
//     {
//         id: 2,
//         title: 'Animatronics',
//         defaultDevice: 'Humanoid',
//         content: [
//             {
//                 device: 'Klaw',
//                 name: 'Klaw-b',
//                 src: 'klaw',
//                 nav: '',
//             },
//             {
//                 device: 'Hexapod',
//                 name: 'Crawl-e',
//                 src: 'crawle',
//                 nav: '',
//             },
//             {
//                 device: 'Humanoid',
//                 name: 'Zing',
//                 src: 'zing',
//                 nav: '',
//             },
//         ],
//     },
//     {
//         id: 3,
//         title: 'RoboticKits',
//         defaultDevice: 'Atr',
//         content: [
//             {
//                 device: 'Atr',
//                 name: 'Atr',
//                 src: 'ATRkit',
//                 nav: '',
//             },
//         ],
//     },
//     {
//         id: 4,
//         title: 'Electronics',
//         defaultDevice: 'Trons',
//         content: [
//             {
//                 name: 'Playtrons',
//                 src: 'trons',
//                 nav: 'https://playtrons.plode.org/projects',
//             },
//             {
//                 name: 'Playtronix',
//                 src: 'tronix',
//                 nav: 'https://playtronix.plode.org/',
//             },

//             // {
//             //     name: 'Plode X',
//             //     src: 'plodeX',
//             //     nav: 'https://plodex.plode.org/workspace',
//             // },
//         ],
//     },
//     {
//         id: 5,
//         title: 'Mechanical',
//         defaultDevice: 'Trons',
//         content: [
//             {
//                 name: 'Playdynamex',
//                 src: 'kitSelectionDynamex',
//                 nav: 'https://plode.org/play/#/playdynamex',
//             },
//             // {
//             //     name: 'Plode X',
//             //     src: 'plodeX',
//             //     nav: 'https://plodex.plode.org/workspace',
//             // },
//         ],
//     },
// ]

function getCompletedSubprograms() {
    try {
        const saved = sessionStorage.getItem('completedSubprograms')
        return saved ? JSON.parse(saved) : []
    } catch {
        return []
    }
}

const KitSelection = (props) => {
    const [isHelp, setHelp] = useState(false)
    const [search, setSearch] = useState('')
    // const [activeTab, setActiveTab] = useState(tabs[0].id)
    const [filteredResults, setFilteredResults] = useState({})
    const [suggestions, setSuggestions] = useState([])
    const [showLanguagePopup, setShowLanguagePopup] = useState(false)
    const [languageValue, setLanguageValue] = useState(props.device.language)
    const [codableKitItems, setCodableKitItems] = useState([])
    const [expansionKitItems, setExpansionKitItems] = useState([])
    // Subprograms across all programs — used only for search suggestions
    const [subprogramItems, setSubprogramItems] = useState([])

    const [modelData, setModelData] = useState({
        isShow: false,
        text: '',
        type: '',
    })

    const languageName = props.device.language

    // ADD THESE LINES RIGHT HERE:
    const [completed, setCompleted] = useState([])

    useEffect(() => {
        setCompleted(getCompletedSubprograms())
    }, [])

    // const [slideDirection, setSlideDirection] = useState(
    //     sessionStorage.getItem('slideDirection')
    // )
    // const optionsToSelect = [
    //     {
    //         text: 'YES',
    //         do: async () => {
    //             console.log(activeTab)
    //             if (activeTab == 3) {
    //                 window.location.href = 'https://playtrons.plode.org/'
    //                 return
    //             }
    //             let connectedDevice = tabs[activeTab - 1].defaultDevice
    //             console.log(tabs[activeTab])
    //             sessionStorage.setItem('connectedDevice', connectedDevice)
    //             let { latestVersion } = await fetchVersion(
    //                 // 'https://embedded.plode.org/version-list',
    //                 'https://embedded.plode.org/version-list-v2',
    //                 connectedDevice
    //                 // connectedDevice == 'Ace' ? '1.0' : '2.0'
    //             )

    //             sessionStorage.setItem(
    //                 'deviceVersion',
    //                 latestVersion.slice(0, latestVersion.length - 2)
    //             )
    //             history.push('/Selection')
    //         },
    //     },
    //     { text: 'NO', do: () => setShowDialog(false) },
    // ]

    const history = useHistory()

    // Fetch programs for Codable Kits tab display, and subprograms for search
    useEffect(() => {
        fetch(`${BACKEND_URL}/api/programs`)
            .then((res) => res.json())
            .then(async (programs) => {
                // Program-level cards shown in the tab
                const cards = programs.map((prog) => ({
                    id: prog.id,
                    name: prog.title,
                    imageSrc: PROGRAM_IMAGE_MAP[prog.id] || 'toki',
                    nav: PROGRAM_ENGINE_ROUTE[prog.id] || '/make',
                    isProgramCard: true,
                    device: prog.title,
                }))
                setCodableKitItems(cards)

                // Subprograms fetched from all programs for search use
                const allSubs = await Promise.all(
                    programs.map((prog) =>
                        fetch(`${BACKEND_URL}/api/program/${prog.id}`)
                            .then((r) => r.json())
                            .then((data) =>
                                (data.subprograms || []).map((sub) => ({
                                    id: sub.id,
                                    device: prog.title,
                                    name: sub.title,
                                    backendImage: sub.image,
                                    nav: `/make/${sub.id}`,
                                    isCodableKit: true,
                                    programId: prog.id,
                                    // Expansion kit this subprogram belongs to (if any)
                                    kit: sub.kit,
                                }))
                            )
                            .catch(() => [])
                    )
                )
                setSubprogramItems(allSubs.flat())
            })
            .catch((err) => {
                console.error('Failed to load programs:', err)
            })
    }, [])

    // Fetch Expansion Kits (same card shape as Codable Kits; content wired later)
    useEffect(() => {
        fetch(`${BACKEND_URL}/api/expansion-kits`)
            .then((res) => res.json())
            .then((kits) => {
                setExpansionKitItems(
                    kits.map((kit) => ({
                        id: kit.id,
                        name: kit.title,
                        // FIX: Check if image parameter is an uploaded backend hash string or fallback to hardcoded rule
                        imageSrc: kit.image,
                        nav: `/expansionKitSelection?expansionKitDevice=${kit.id}`,
                        isExpansionKit: true,
                        device: kit.title,
                    }))
                )
            })
            .catch((err) => {
                console.error('Failed to load expansion kits:', err)
            })
    }, [])

    // Admin keyboard shortcut: Cmd+Shift+Y (Mac) or Ctrl+Shift+Y (Win/Linux)
    useEffect(() => {
        const handleKeyDown = (e) => {
            const isMac = navigator.userAgent.toUpperCase().includes('MAC')
            const isMacShortcut =
                isMac && e.metaKey && e.shiftKey && e.key.toLowerCase() === 'y'
            const isWinShortcut =
                !isMac && e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'y'
            if (isMacShortcut || isWinShortcut) {
                e.preventDefault()
                history.push('/admin')
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [history])
    const handleHelpBtn = (e) => {
        if (isHelp == true) {
            setHelp(false)
        } else {
            setHelp(true)
        }
    }
    const gobackUrl = () => {
        // setSlideDirection(true)
        sessionStorage.setItem('slideDirection', true)
        history.push('/')
    }

    const handleAutoConnection = () => {
        props.setSelectionBackRoute('/kitSelection')
        history.push('/deviceSelection')
    }
    const handleDefaultConnection = () => {}
    const handleDeviceConnection = async (item) => {
        // Expansion kit cards → remember the chosen kit, then go pick a device
        // (card clicks carry the id on `item.id`; search results on `expansionKitId`)
        if (item.isExpansionKit) {
            sessionStorage.setItem(
                'expansionKit',
                item.expansionKitId || item.id
            )
            history.push(item.nav)
            return
        }

        // Any non-expansion selection clears the kit filter used by /make
        sessionStorage.removeItem('expansionKit')

        // Handle program-level cards (toki, poki engine redirects)
        if (item.isProgramCard) {
            sessionStorage.setItem('connectedDevice', item.device)
            sessionStorage.setItem('allowedDevice', item.device)

            // Fetch the latest version for the device
            try {
                let { latestVersion } = await fetchVersion(
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].deviceName
                        : 'Playcomputer',
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].version
                        : '1.0'
                )
                sessionStorage.setItem(
                    'deviceVersion',
                    latestVersion.slice(0, latestVersion.length - 2)
                )
            } catch (error) {
                console.error('Failed to fetch version:', error)
                // Fallback to default version if fetch fails
                sessionStorage.setItem('deviceVersion', '1')
            }

            history.push(item.nav)
            return
        }

        // Handle codable kit subprograms (from search results)
        if (item.isCodableKit) {
            sessionStorage.setItem('connectedDevice', item.device)
            sessionStorage.setItem('allowedDevice', item.device)

            // Fetch the latest version for the device
            try {
                let { latestVersion } = await fetchVersion(
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].deviceName
                        : 'Playcomputer',
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].version
                        : '1.0'
                )
                sessionStorage.setItem(
                    'deviceVersion',
                    latestVersion.slice(0, latestVersion.length - 2)
                )
            } catch (error) {
                console.error('Failed to fetch version:', error)
                sessionStorage.setItem('deviceVersion', '1')
            }

            history.push(item.nav)
            return
        }

        if (['Dynamex'].includes(item.name)) {
            window.open(item.nav, '_blank')
            return
        }

        if (['Dynamex-2', 'Mex'].includes(item.name)) {
            window.open(item.nav, '_self')
            return
        }

        if (['Playtrons', 'Playtronix'].includes(item.name))
            window.open(item.nav, '_blank')
        else if (['pcAiTool', 'Ai0'].includes(item.device)) {
            props.setSelectedKit({ ...item, aiKitSelected: item.device })
            history.push({
                pathname: '/aiKitSelection',
                search: `?aiDevice=${item.device}`,
            })
        } else {
            props.setSelectedKit({ ...item, aiKitSelected: '' })
            sessionStorage.setItem('allowedDevice', item.device)
            props.setSelectionBackRoute('/kitSelection')
            history.push('/deviceSelection')
        }

        if (item.device === 'Toki' && item.nav) {
            sessionStorage.setItem('connectedDevice', 'Toki')
            sessionStorage.setItem('allowedDevice', 'Toki')

            // Fetch the latest version for Toki
            try {
                let { latestVersion } = await fetchVersion(
                    getVersionArguments['Toki'].deviceName,
                    getVersionArguments['Toki'].version
                )
                sessionStorage.setItem(
                    'deviceVersion',
                    latestVersion.slice(0, latestVersion.length - 2)
                )
            } catch (error) {
                console.error('Failed to fetch Toki version:', error)
                sessionStorage.setItem('deviceVersion', '1')
            }

            history.push(item.nav)
            return
        }

        sessionStorage.setItem('allowedDevice', item.device)
        props.setSelectionBackRoute('/kitSelection')
        history.push('/deviceSelection')
    }
    useEffect(() => {
        console.log('search', filteredResults)
        // if (search.length == 0) {
        //     // setActiveTab(1)
        //     setFilteredResults({})
        // } else
        if (Object.keys(filteredResults).length > 0) {
            props.setActiveTab(filteredResults.id)
        }
    }, [search])
    // console.log(activeTab)
    const handleSearch = (e) => {
        const value = e.target.value

        setSearch(e.target.value)
        if (!e.target.value.trim()) {
            props.setActiveTab(1)
            setFilteredResults({})
        }
        if (value) {
            const allSuggestions = [
                ...[...tabs].flatMap((tab) =>
                    tab.content.map((item) => ({
                        name: item.name,
                        src: item.src,
                        nav: item.nav,
                        title: tab.title,
                        id: tab.id,
                        device: item.device,
                    }))
                ),
                // Search over subprograms (not the program cards)
                ...subprogramItems.map((item) => ({
                    name: item.name,
                    src: item.backendImage,
                    nav: item.nav,
                    title: 'Codable Kits',
                    id: 2,
                    subprogramId: item.id,
                    device: item.device,
                    isCodableKit: true,
                    backendImage: item.backendImage,
                })),
                // Search over expansion kits
                ...expansionKitItems.map((item) => ({
                    name: item.name,
                    src: item.imageSrc,
                    nav: item.nav,
                    title: 'Expansion Kits',
                    id: 3,
                    expansionKitId: item.id,
                    device: item.device,
                    isExpansionKit: true,
                })),
            ]
            const filteredSuggestions = allSuggestions.filter((suggestion) =>
                suggestion.name.toLowerCase().includes(value.toLowerCase())
            )
            console.log(filteredSuggestions)
            setSuggestions(filteredSuggestions)
        } else {
            setSuggestions([])
        }
    }
    const handleSuggestion = (suggestion) => {
        setSearch(suggestion.name)
        setFilteredResults(suggestion)
        setSuggestions([])
    }

    const languageActionHandel = () => {
        props.setLanguageSelect({ language: languageValue })
        setShowLanguagePopup(false)
    }
    const handelTabsChange = (tab) => {
        if (filteredResults && Object.keys(filteredResults).length > 0) {
            setSearch('')
            setFilteredResults({})
        }

        props.setActiveTab(tab.id)
    }

    // Expansion kits that have at least one subprogram/project.
    // Kits absent from this set are shown as "COMING SOON" (disabled).
    const expansionKitsWithProjects = new Set(
        subprogramItems.filter((sub) => sub.kit).map((sub) => sub.kit)
    )

    return (
        <>
            <DialogModal
                show={showLanguagePopup}
                text={
                    <div>
                        <p>Select Your Prefer language</p>
                        <div>
                            <select
                                className={KitSelectStyle.language_select}
                                value={languageValue}
                                onChange={(e) =>
                                    setLanguageValue(e.target.value)
                                }
                            >
                                {languageMenu.map((ele) => {
                                    return (
                                        <option key={ele} value={ele}>
                                            {ele}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setShowLanguagePopup(false)}
                optionsToSelect={[
                    {
                        text: 'CONTINUE',
                        do: () => {
                            languageActionHandel()
                        },
                    },
                ]}
            />

            <div className={KitSelectStyle.container}>
                <div className={KitSelectStyle.Connect_Header}>
                    {isHelp ? (
                        <div>
                            <img
                                className={KitSelectStyle.back_btn}
                                style={{ zIndex: '-1' }}
                                src={renderImage('backBtn')}
                                onClick={gobackUrl}
                            ></img>{' '}
                        </div>
                    ) : (
                        <div className="">
                            <img
                                className={KitSelectStyle.back_btn}
                                style={{ zIndex: '1000' }}
                                src={renderImage('backBtn')}
                                onClick={gobackUrl}
                            ></img>{' '}
                        </div>
                    )}
                    <p className={KitSelectStyle.text}>
                        {languageWords[languageName]?.SelectDevice ||
                            'Select your Kit'}
                    </p>
                    <div>
                        {isHelp == false && (
                            <div>
                                <div className="header_button">
                                    <img
                                        className={KitSelectStyle.helpBtn}
                                        src={renderImage(
                                            'activeAdvanceSetting'
                                        )}
                                        onClick={() =>
                                            setShowLanguagePopup(true)
                                        }
                                        // style={{ right: '30%' }}
                                    ></img>
                                    <span
                                        className="tooltiptext"
                                        style={{
                                            // top: '13vh',
                                            zIndex: '1',
                                        }}
                                    >
                                        {' '}
                                        <p>Language</p>
                                    </span>
                                </div>
                                <div className={KitSelectStyle.searchInput}>
                                    <input
                                        type="text"
                                        name="search"
                                        value={search}
                                        onChange={handleSearch}
                                    />
                                    {Object.keys(filteredResults).length > 0 ? (
                                        <div
                                            className={KitSelectStyle.binIcon}
                                            onClick={() => {
                                                setSearch('')
                                                props.setActiveTab(1)
                                                setFilteredResults({})
                                            }}
                                        >
                                            <img
                                                src="https://cdn-icons-png.flaticon.com/128/2976/2976286.png"
                                                alt="bin"
                                            />
                                            {/* <img
                                                    src="https://cdn-icons-png.flaticon.com/128/3395/3395538.png"
                                                    alt="search"
                                                /> */}
                                            {/* </div> */}
                                        </div>
                                    ) : (
                                        <div
                                            className={
                                                KitSelectStyle.searchIcon
                                            }
                                        >
                                            <img
                                                src={renderImage('searchIcon')}
                                                alt="search"
                                            />
                                        </div>
                                    )}
                                    {suggestions.length > 0 && (
                                        <ul
                                            className={
                                                KitSelectStyle.suggestions
                                            }
                                        >
                                            {suggestions.map(
                                                (suggestion, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() =>
                                                            handleSuggestion(
                                                                suggestion
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            width={'24px'}
                                                            src={
                                                                suggestion.isCodableKit
                                                                    ? getBackendImage(
                                                                          suggestion.backendImage ||
                                                                              'projectDefault'
                                                                      )
                                                                    : renderImage(
                                                                          suggestion.src
                                                                      )
                                                            }
                                                            alt={
                                                                suggestion.title
                                                            }
                                                        />
                                                        {/* <span
                                                            className={
                                                                KitSelectStyle.suggestion_title
                                                            }
                                                        >
                                                            {suggestion.title}
                                                        </span>{' '}
                                                        / */}
                                                        <span
                                                            className={
                                                                KitSelectStyle.suggestion_name
                                                            }
                                                        >
                                                            {suggestion.name}
                                                        </span>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    )}
                                </div>
                                {/* <div className="header_button">
                                    <img
                                        className={KitSelectStyle.helpBtn}
                                        src={renderImage('helpBtnInActive')}
                                        onClick={handleHelpBtn}
                                    ></img>
                                    <span className="tooltiptext">
                                        {' '}
                                        <p>Help</p>
                                    </span>
                                </div> */}
                            </div>
                        )}
                    </div>
                </div>

                <div className={KitSelectStyle.Connect_Body}>
                    <div className={KitSelectStyle.tabsParent}>
                        <p className={KitSelectStyle.header}>
                            {languageWords[languageName]?.Device || 'Kits'}
                        </p>

                        <div className={KitSelectStyle.tabs}>
                            {tabs.map((tab) => (
                                <div
                                    key={tab.id}
                                    className={`${KitSelectStyle.tab} ${
                                        tab.id ===
                                        props.device.kitSelection.activeTab
                                            ? KitSelectStyle.active
                                            : ''
                                    }`}
                                    onClick={() => handelTabsChange(tab)}
                                >
                                    <p className={KitSelectStyle.title}>
                                        {languageWords[languageName]?.[
                                            tab.title
                                        ] || tab.title}
                                    </p>
                                    {tab.id ===
                                        props.device.kitSelection.activeTab && (
                                        <div className={KitSelectStyle.arrow}>
                                            <img
                                                src={renderImage('arrowRight')}
                                                alt="arrowRight"
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={KitSelectStyle.content}>
                        {filteredResults &&
                        Object.keys(filteredResults).length > 0 ? (
                            <div className={KitSelectStyle.tabContent}>
                                {(() => {
                                    // Check if the filtered result is a completed codable kit
                                    const isCompleted =
                                        filteredResults.isCodableKit &&
                                        completed.includes(
                                            filteredResults.subprogramId
                                        )

                                    return (
                                        <div
                                            onClick={() =>
                                                handleDeviceConnection(
                                                    filteredResults
                                                )
                                            }
                                            className={`${KitSelectStyle.card} ${isCompleted ? KitSelectStyle.cardCompleted : ''}`}
                                        >
                                            <div
                                                className={
                                                    KitSelectStyle.cardImg
                                                }
                                                style={{ position: 'relative' }}
                                            >
                                                <img
                                                    src={
                                                        filteredResults.isCodableKit
                                                            ? getBackendImage(
                                                                  filteredResults.backendImage ||
                                                                      'projectDefault'
                                                              )
                                                            : renderImage(
                                                                  filteredResults.src
                                                              )
                                                    }
                                                    alt={filteredResults.name}
                                                    className={
                                                        isCompleted
                                                            ? KitSelectStyle.imageCompleted
                                                            : ''
                                                    }
                                                />
                                                {/* Add Badge to search results too */}
                                                {isCompleted && (
                                                    <div
                                                        className={
                                                            KitSelectStyle.completedBadge
                                                        }
                                                    >
                                                        <svg
                                                            viewBox="0 0 24 24"
                                                            width="22"
                                                            height="22"
                                                        >
                                                            <circle
                                                                cx="12"
                                                                cy="12"
                                                                r="12"
                                                                fill="#4caf50"
                                                            />
                                                            <path
                                                                d="M7 12l3 3 7-7"
                                                                fill="none"
                                                                stroke="white"
                                                                strokeWidth="2.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </div>
                                                )}
                                            </div>
                                            <p
                                                className={`${KitSelectStyle.cardName} ${isCompleted ? KitSelectStyle.textCompleted : ''}`}
                                            >
                                                {filteredResults.name}
                                            </p>
                                        </div>
                                    )
                                })()}
                            </div>
                        ) : (
                            <>
                                {tabs.map(
                                    (tab, index) =>
                                        tab.id ===
                                            props.device.kitSelection
                                                .activeTab && (
                                            <div
                                                key={index}
                                                className={
                                                    KitSelectStyle.tabContent
                                                }
                                            >
                                                {/* Codable / Expansion Kits: show dynamically fetched cards */}
                                                {tab.title === 'Codable Kits' ||
                                                tab.title === 'Expansion Kits'
                                                    ? (tab.title ===
                                                      'Expansion Kits'
                                                          ? expansionKitItems
                                                          : codableKitItems
                                                      ).map((item) => {
                                                          // Expansion kit with no projects → "COMING SOON" (disabled)
                                                          const isEmptyExpansionKit =
                                                              item.isExpansionKit &&
                                                              !expansionKitsWithProjects.has(
                                                                  item.id
                                                              )

                                                          return (
                                                          <div
                                                              key={item.id}
                                                              onClick={() =>
                                                                  isEmptyExpansionKit
                                                                      ? undefined
                                                                      : handleDeviceConnection(
                                                                            item
                                                                        )
                                                              }
                                                              className={
                                                                  KitSelectStyle.card
                                                              }
                                                              style={
                                                                  isEmptyExpansionKit
                                                                      ? {
                                                                            cursor: 'not-allowed',
                                                                        }
                                                                      : undefined
                                                              }
                                                          >
                                                              <div
                                                                  className={
                                                                      KitSelectStyle.cardImg
                                                                  }
                                                                  style={{
                                                                      position:
                                                                          'relative',
                                                                  }}
                                                              >
                                                                  <img
                                                                      src={
                                                                          // Expansion kits use backend-delivered images; codable kits keep local renderImage keys
                                                                          item.isExpansionKit
                                                                              ? getBackendImage(
                                                                                    item.imageSrc ||
                                                                                        'PokiRoverKit.png'
                                                                                )
                                                                              : renderImage(
                                                                                    item.imageSrc
                                                                                )
                                                                      }
                                                                      alt={
                                                                          item.name
                                                                      }
                                                                      style={{
                                                                          width: '100%',
                                                                          objectFit:
                                                                              'contain',
                                                                          filter: isEmptyExpansionKit
                                                                              ? 'grayscale(0%)'
                                                                              : undefined,
                                                                              opacity: isEmptyExpansionKit ? 0.7 : 1,
                                                                      }}
                                                                  />
                                                                  {isEmptyExpansionKit && (
                                                                      <div
                                                                          className={
                                                                              KitSelectStyle.comingSoonOverlay
                                                                          }
                                                                      >
                                                                          <div
                                                                              className={
                                                                                  KitSelectStyle.comingSoonBanner
                                                                              }
                                                                          >
                                                                              {
                                                                                  COMING_SOON_TEXT
                                                                              }
                                                                          </div>
                                                                      </div>
                                                                  )}
                                                              </div>
                                                              <div>
                                                                  <p
                                                                      className={
                                                                          KitSelectStyle.cardName
                                                                      }
                                                                  >
                                                                      {
                                                                          item.name
                                                                      }
                                                                  </p>
                                                              </div>
                                                          </div>
                                                          )
                                                      })
                                                    : tab.content.map(
                                                          (item, index) => (
                                                              <div
                                                                  key={index}
                                                                  onClick={() =>
                                                                      handleDeviceConnection(
                                                                          item
                                                                      )
                                                                  }
                                                                  className={
                                                                      KitSelectStyle.card
                                                                  }
                                                              >
                                                                  <div
                                                                      className={
                                                                          KitSelectStyle.cardImg
                                                                      }
                                                                  >
                                                                      <img
                                                                          src={renderImage(
                                                                              item.src
                                                                          )}
                                                                          alt={
                                                                              item.src
                                                                          }
                                                                      />
                                                                  </div>

                                                                  <div>
                                                                      <p
                                                                          className={
                                                                              KitSelectStyle.cardName
                                                                          }
                                                                          style={
                                                                              codableKits.includes(
                                                                                  item.id
                                                                              )
                                                                                  ? {
                                                                                        marginBottom:
                                                                                            '0px',
                                                                                    }
                                                                                  : {}
                                                                          }
                                                                      >
                                                                          {
                                                                              item.name
                                                                          }
                                                                      </p>

                                                                      {codableKits.includes(
                                                                          item.id
                                                                      ) && (
                                                                          <p
                                                                              className={
                                                                                  KitSelectStyle.cardDeviceName
                                                                              }
                                                                          >
                                                                              {
                                                                                  item.device
                                                                              }
                                                                          </p>
                                                                      )}
                                                                  </div>
                                                              </div>
                                                          )
                                                      )}
                                            </div>
                                        )
                                )}
                            </>
                        )}
                    </div>
                </div>

                <div className={KitSelectStyle.Connect_Footer}>
                    {/* <div
                        className={KitSelectStyle.navigate}
                        onClick={() => setShowDialog(true)}
                    >
                        <img
                            src={renderImage('doubleArrow')}
                            alt="arrowRight"
                        />
                    </div> */}
                    <div
                    // className={KitSelectStyle.auto}
                    >
                        <img
                            style={{ width: '90px', cursor: 'pointer' }}
                            src={renderImage('auto')}
                            alt="arrowRight"
                            onClick={handleAutoConnection}
                        />
                    </div>
                </div>
            </div>

            {isHelp && (
                <div
                    style={{
                        height: '100vh',
                        width: '100vw',
                        background: '#fff',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        zIndex: '1000',
                        position: 'absolute',
                    }}
                >
                    <div
                        style={{
                            transform: 'translate(-50%,-50%)',
                            top: '47%',
                            left: '50%',
                            zIndex: '10',
                            position: 'absolute',
                            width: '65vw',
                        }}
                    >
                        <div className={KitSelectStyle.web_button}>
                            <img
                                className={KitSelectStyle.Cross}
                                src={renderImage('clos')}
                                onClick={handleHelpBtn}
                            ></img>
                        </div>
                        <div>
                            <img
                                src={
                                    sessionStorage.getItem(
                                        'connectedDevice'
                                    ) === 'Humanoid'
                                        ? renderImage('ZingConnect')
                                        : renderImage('Connect')
                                }
                                style={{
                                    width: '100%',
                                }}
                            ></img>
                        </div>
                        <div className={KitSelectStyle.instr}>
                            <p className={KitSelectStyle.instr_P}>
                                {' '}
                                Help Button will explain all the features and
                                functionality of the entire app for each
                                screen{' '}
                            </p>
                        </div>
                        <div className={KitSelectStyle.instr2}>
                            <p className={KitSelectStyle.instr2_P}>
                                Manual scan will list all the Playcomputer
                                devices if multiple devices are ON
                            </p>
                        </div>
                        <div className={KitSelectStyle.instr3}>
                            <p className={KitSelectStyle.instr3_P}>
                                Skip button will skip the scanning and
                                connecting over bluetooth to playcomputer.If you
                                skip you will not be able to send data to
                                playcomputer.{' '}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        setLanguageSelect: (data) => {
            dispatch(setLanguageSelect(data))
        },
        setSocket: (data) => {
            dispatch({ type: 'SOCKET', payload: data })
        },
        setSelectedKit: (data) => {
            dispatch({ type: 'SET_SELECTED_KIT', payload: data })
        },
        setActiveTab: (data) => {
            dispatch({ type: 'SET_ACTIVE_TAB', payload: data })
        },
        setSelectionBackRoute: (data) => {
            dispatch(setSelectionBackRoute(data))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(KitSelection)
